import * as React from "react";
import PropTypes from "../../../../prop-types/index.es.js";
import "../../../../react/jsx-runtime.es.js";
const RtlContext = /* @__PURE__ */ React.createContext();
process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  value: PropTypes.bool
} : void 0;
const useRtl = () => {
  const value = React.useContext(RtlContext);
  return value != null ? value : false;
};
export {
  useRtl
};
//# sourceMappingURL=index.es.js.map
